const SmartForm = ({ id }) => {
    return (
        <div>
            <h1>Smart Form - {id}</h1>
        </div>
    )
}

export default SmartForm